import React from 'react';
import { Button, CHECKOUT_URL } from '../ui/Button';
export function FinalCTA() {
  return <section className="py-24 bg-brand-dark text-white text-center" data-id="element-9">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold mb-8 leading-tight" data-id="element-11">
          Tu primer triatlón empieza{' '}
          <span className="text-brand-green italic" data-id="element-12">hoy</span>.
        </h2>
        <p className="text-xl text-slate-300 mb-12 max-w-2xl mx-auto" data-id="element-13">
          No dejes que la falta de tiempo sea una excusa. Obtené el sistema
          completo + los 3 bonos gratis y empezá a entrenar de forma
          inteligente.
        </p>

        <Button href={CHECKOUT_URL} className="px-10 py-5 text-xl w-full sm:w-auto shadow-xl shadow-brand-green/20" data-id="element-14">
          → QUIERO ENTRENAR SIN CAOS
        </Button>

        <p className="mt-8 text-sm text-slate-400" data-id="element-15">
          Acceso inmediato • Pago único • Garantía de 7 días
        </p>
      </div>
    </section>;
}